import React, { useEffect, useRef } from "react";
import { Column } from "@/shared/ui/Blocks";
import { ChatMessage as ChatMessageType } from "@/shared/contexts/gptgateway.context";

export interface MessagesListProps {
  messages: ChatMessageType[];
  renderItem: (message: ChatMessageType) => React.ReactNode;
  toolCallLoader?: React.ReactNode;
}

export const MessagesList: React.FC<MessagesListProps> = (props) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    if (!messagesEndRef.current || !containerRef.current) return;

    const container = containerRef.current;
    const isOverflowing = container.scrollHeight > container.clientHeight;

    if (isOverflowing) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [props.messages, props.toolCallLoader]);

  return (
    <Column
      ref={containerRef}
      className="flex-1 w-full overflow-y-auto gap-4 pb-4"
    >
      {props.messages.map((message, index) => (
        <React.Fragment key={index}>{props.renderItem(message)}</React.Fragment>
      ))}
      {props.toolCallLoader}
      <div ref={messagesEndRef} />
    </Column>
  );
};
